import React from 'react';

import { Typography } from '@mui/material';

export default function DealFieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      variant="caption"
      color="text.primary"
      fontWeight={700}
      sx={{ letterSpacing: 0.6, whiteSpace: 'nowrap' }}
    >
      {children}
    </Typography>
  );
}
